<template>
    <div>
        <div class="d-flex flex-stack flex-wrap">
            <div class="page-title d-flex flex-column me-3 mt-3">
                <h1 class="d-flex fw-bolder my-1 fs-3 text-gray-800">{{ $t('balance_closing_operations') }}
                </h1>
                <ul class="breadcrumb breadcrumb-dot fw-bold text-gray-600 fs-7 my-1">
                    <li class="breadcrumb-item text-gray-600">
                        <a href="#" class="text-gray-600 text-hover-primary">
                            <router-link :to="{ name: 'Home' }">{{ $t('home') }}</router-link>
                        </a>
                    </li>
                    <li class="breadcrumb-item text-primary">{{$t('transactions')}}</li>
                    <li class="breadcrumb-item text-gray-600">{{ $t('balance_closing_operations') }}
                    <HelpPageIcon v-if="this.iconView == true" :menuSelection="this.menuSelection"></HelpPageIcon>
                    </li>
                </ul>
            </div>
            <div class="d-flex align-items-center py-1">
                <button v-if="form.activeView > 1" type="button" class="btn btn-light shadow-sm btn-arrow-left border border-gray-400 me-3" @click="onBackStep()">
                    <span class="ms-2 fs-7"> {{ $t('return_back_to_criterias') }}</span>
                </button>
                <button class="btn btn-light-danger border border-danger justify-content-end float-end me-5" @click="onClickCancel()" v-if="form.activeView > 1">
                    {{ $t('cancel') }}
                </button>
                <button type="button" class="btn btn-light border border-gray-400" data-bs-toggle="modal" v-if="this.$isCredentialActive(26,'R')" data-bs-target="#kt_modal_transaction_list" @click="onOpenTransactionListModal()" :disabled="!this.$getUser().is_allow_list_all_data && (this.form.account_id == null || this.form.account_id == undefined || this.form.account_id == '-1')">
                    <span class="svg-icon svg-icon-muted"><svg width="16" height="15" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect y="6" width="16" height="3" rx="1.5" fill="currentColor"/>
                    <rect opacity="0.3" y="12" width="8" height="3" rx="1.5" fill="currentColor"/>
                    <rect opacity="0.3" width="12" height="3" rx="1.5" fill="currentColor"/>
                    </svg>
                    </span>
                    {{$t('transaction_list')}}
                </button>
            </div>
        </div>
        <div class="content flex-row-fluid mt-2">
            <RequiredField></RequiredField>
            <div class="card card-xxl-stretch">
                <div class="row p-4" :class="{'pt-5': form.activeView == 2}">
                    <form id="poliform" @submit.prevent="" class="form fv-plugins-bootstrap5 fv-plugins-framework">
                        <div class="row" v-if="form.activeView == 1">
                            <div class="col-lg-9">
                                <div class="row g-xl-9">
                                    <div class="d-flex flex-column flex-row-auto col-lg-5">
                                        <div class="d-flex flex-column-fluid card card-xxl-stretch mb-5 mb-xxl-10 bg-lighten rounded-3 border border-gray-300"> 
                                            <div class="card-header">
                                                <div class="card-title">
                                                    <h3 class="text-gray-800 me-3"> {{ $t('select_account') }} </h3>
                                                </div>
                                                <div class="card-toolbar">
                                                    <button ref="AddNewContactButton" type="button" class="d-none btn btn-light-primary border border-primary btn-sm justify-content-end"
                                                        @click="openCreateContactModal()" data-bs-toggle="modal" data-bs-target="#kt_modal_add_contact">
                                                        <span class="svg-icon svg-icon-2">
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                                                viewBox="0 0 24 24" fill="none">
                                                                <path
                                                                    d="M20 14H18V10H20C20.6 10 21 10.4 21 11V13C21 13.6 20.6 14 20 14ZM21 19V17C21 16.4 20.6 16 20 16H18V20H20C20.6 20 21 19.6 21 19ZM21 7V5C21 4.4 20.6 4 20 4H18V8H20C20.6 8 21 7.6 21 7Z"
                                                                    fill="currentColor"></path>
                                                                <path opacity="0.3"
                                                                    d="M17 22H3C2.4 22 2 21.6 2 21V3C2 2.4 2.4 2 3 2H17C17.6 2 18 2.4 18 3V21C18 21.6 17.6 22 17 22ZM10 7C8.9 7 8 7.9 8 9C8 10.1 8.9 11 10 11C11.1 11 12 10.1 12 9C12 7.9 11.1 7 10 7ZM13.3 16C14 16 14.5 15.3 14.3 14.7C13.7 13.2 12 12 10.1 12C8.10001 12 6.49999 13.1 5.89999 14.7C5.59999 15.3 6.19999 16 7.39999 16H13.3Z"
                                                                    fill="currentColor"></path>
                                                            </svg>
                                                        </span>
                                                        {{ $t('create_new_account') }}
                                                    </button>
                                                </div>
                                            </div>
                                            <div class="card-body">
                                                <div class="fv-row row">
                                                    <div class="col-lg-12">
                                                        <label class="fs-6 fw-bold form-label mt-3" v-tag="'contact_name'">
                                                            <span>{{ $t('search_account') }}</span>
                                                        </label>
                                                        <div class="input-group">
                                                            <button type="button" class="btn rounded-start-0 btn-light btn-icon text-hover-primary border border-1 border-gray-300 z-index-0" data-bs-toggle="modal" data-bs-target="#kt_modal_account_report_selection" @click="onOpenAccountReport()"
                                                                v-if="form.account_id !== null && form.account_id !== '' && form.account_id !== undefined ">
                                                                <i class="fa fa-eye text-gray-600 fs-3"></i>
                                                            </button>
                                                            <input type="search" class="form-control form-control-lg" v-model="form.account_name" @input="form.account_id = null" :placeholder="$t('please_type_an_account')" @keyup.enter="onClickSearchButton('searchBalanceClosingAccountButton')" name="contact_name" v-custom >
                                                            <button ref="searchBalanceClosingAccountButton" type="button" class="btn btn-sm btn-light-primary border border-gray-300 z-index-0" data-bs-toggle="modal" data-bs-target="#kt_search_account_modal" 
                                                                data-kt-indicator="on" @click="openSearchModal(12, form.account_name)">
                                                                <i class="fa fa-search"></i>
                                                                {{ $t('search') }}
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="d-flex flex-column flex-row-auto col-lg-7">
                                        <div class="d-flex flex-column-fluid card card-xxl-stretch mb-5 mb-xxl-10 bg-lighten rounded-3 border border-gray-300"> 
                                            <div class="card-header">
                                                <div class="card-title">
                                                    <h3 class="text-gray-800 me-3">{{$t('select_balance_closing_type')}}</h3>
                                                </div>
                                            </div>
                                            <div class="card-body">
                                                <div class="fv-row mb-7 row">
                                                    <div class="col-lg-4">
                                                        <label class="fs-6 fw-bold form-label mt-3" v-tag="'balance_closing_type'">
                                                            <span>{{ $t('balance_closing_type') }}</span>
                                                        </label>
                                                        <Select2 v-model="form.balance_closing_type" :options="balanceClosingTypeList" name="balance_closing_type" v-custom :settings="{ width: '100%' }"/>
                                                    </div>
                                                    <div class="col-lg-4">
                                                        <div class="fv-row mb-1 fv-plugins-icon-container">
                                                            <label class="fs-6 fw-bold form-label mt-3" v-tag="'transaction_start_date'">
                                                                {{ $t('transaction_start_date') }}
                                                            </label>
                                                            <Datepicker :locale="$datepickerLocale()"  name="transaction_start_date" :required="this.$checkIfDateFieldRequired ('transaction_start_date')" textInput :textInputOptions="{ format: 'dd.MM.yyyy' }" v-maska="'##.##.####'" v-model="form.transaction_start_date" format="dd.MM.yyyy" previewFormat="dd.MM.yyyy" autoApply :clearable="false" 
                                                            :enableTimePicker="false" />
                                                        </div>
                                                    </div>
                                                    <div class="col-lg-4">
                                                        <div class="fv-row mb-1 fv-plugins-icon-container">
                                                            <label class="fs-6 fw-bold form-label mt-3" v-tag="'transaction_end_date'">
                                                                {{ $t('transaction_end_date') }}
                                                            </label>
                                                            <Datepicker :locale="$datepickerLocale()"  name="transaction_end_date" :required="this.$checkIfDateFieldRequired ('transaction_end_date')" textInput :textInputOptions="{ format: 'dd.MM.yyyy' }" v-maska="'##.##.####'" v-model="form.transaction_end_date" format="dd.MM.yyyy" previewFormat="dd.MM.yyyy" autoApply :clearable="false" 
                                                            :enableTimePicker="false" />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-lg-12 mt-0">
                                        <div class="d-grid gap-2">
                                            <button class="btn btn-primary mb-4 fw-boldest" type="submit" @click="changeView(2)" :disabled="form.account_id == null">
                                                <span class="svg-icon svg-icon-2">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                                        viewBox="0 0 24 24" fill="none">
                                                        <path
                                                            d="M20 14H18V10H20C20.6 10 21 10.4 21 11V13C21 13.6 20.6 14 20 14ZM21 19V17C21 16.4 20.6 16 20 16H18V20H20C20.6 20 21 19.6 21 19ZM21 7V5C21 4.4 20.6 4 20 4H18V8H20C20.6 8 21 7.6 21 7Z"
                                                            fill="currentColor"></path>
                                                        <path opacity="0.3"
                                                            d="M17 22H3C2.4 22 2 21.6 2 21V3C2 2.4 2.4 2 3 2H17C17.6 2 18 2.4 18 3V21C18 21.6 17.6 22 17 22ZM10 7C8.9 7 8 7.9 8 9C8 10.1 8.9 11 10 11C11.1 11 12 10.1 12 9C12 7.9 11.1 7 10 7ZM13.3 16C14 16 14.5 15.3 14.3 14.7C13.7 13.2 12 12 10.1 12C8.10001 12 6.49999 13.1 5.89999 14.7C5.59999 15.3 6.19999 16 7.39999 16H13.3Z"
                                                            fill="currentColor"></path>
                                                    </svg>
                                                </span>
                                                {{ $t('start_balance_closing') }}
                                            </button>
                                        </div>
                                    </div>

                                </div>
                            </div>
                            
                           <NoModalRecentlyUsedAccounts  
                                @openAccountReport="onOpenAccountReport"
                                @accountDetail="getAccountDetail"
                                :selected-account-info="this.selectedAccountInfo" 
                                :account-latest-list="this.accountLatestList"
                                :form="this.form"
                                :local-currency="this.localCurrency"
                           />
                        </div>
                    </form>
                    <div class="row" v-if="form.activeView > 1">
                        <div class="d-flex flex-column flex-row-auto col-lg-12"> 
                            <div class="d-flex flex-column-fluid card card-xxl-stretch mb-5 mb-xxl-10 bg-lighten rounded-3 border border-gray-300"> 
                                <div class="card-header rounded-2 rounded-bottom-0 bg-gray-gradient min-h-40px">
                                    <div class="card-title">
                                        <h3> {{ $t('account') }}</h3>
                                    </div>
                                </div>
                                <div class="card-body">
                                    <div class="row">
                                        <div class="col-lg-4">
                                            <div class="d-flex align-items-center justify-content-start flex-equal order-3 fw-row">
                                                <span class="fs-2 fw-bolder text-gray-800">{{selectedAccountInfo.name}}<br>
                                                <span class="text-gray-700">{{selectedAccountInfo.customer_account_number}}</span></span> 
                                                <div class="d-flex justify-content-end ms-3">
                                                    <div class="symbol symbol-100px cursor-pointer"  data-bs-toggle="modal" data-bs-target="#kt_modal_account_report_selection" @click="onOpenAccountReport()">
                                                        <div class="symbol-label fw-bold bg-light border text-hover-primary">
                                                            <i class="fa fa-eye text-gray-600 fs-2x"></i>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-lg-4">
                                            <div class="d-flex align-items-center justify-content-start flex-equal order-3 fw-row mt-2">
                                                <span class="fs-6 fw-bolder text-gray-700 mt-2">
                                                    {{selectedAccountInfo.customer_address}}
                                                </span>
                                            </div>
                                            <div class="d-flex align-items-center justify-content-start flex-equal order-3 fw-row  mt-3">
                                                <span class="fs-6 text-gray-700 fw-bold"> {{selectedAccountInfo.customer_city}} </span>
                                                <span class="fs-6 text-gray-700 fw-bold ms-5"> {{selectedAccountInfo.customer_district}} </span>
                                                <span class="fs-6 text-gray-700 fw-bold ms-5"> {{selectedAccountInfo.customer_country}} </span>
                                                <span class="fs-6 text-gray-700 fw-bold ms-5"> {{selectedAccountInfo.customer_postcode}} </span>
                                            </div>
                                            <div class="d-flex align-items-center justify-content-start flex-equal order-3 fw-row  mt-3">
                                                <a href="{{selectedAccountInfo.customer_email}}" class="fw-bold fs-6"> {{selectedAccountInfo.customer_email}} </a>
                                                <span class="fs-6 text-gray-700 fw-bold ms-5"> {{selectedAccountInfo.customer_mobile_phone}} </span>
                                            </div>
                                        </div>
                                        <div class="col-lg-4">
                                            <div class="d-flex align-items-center justify-content-start flex-equal order-3 fw-row  mt-3">
                                                <span class="fs-6 text-gray-700 fw-bolder"> {{getBalanceClosingTypeName(form.balance_closing_type)}} </span>
                                            </div>
                                            <div class="d-flex align-items-center justify-content-start flex-equal order-3 fw-row mt-2">
                                                <span class="fs-6 text-gray-700 fw-bolder"> 
                                                    {{previewDate(form.transaction_start_date)}}
                                                    <i class="bi bi-dash fw-bolder"></i>
                                                    {{previewDate(form.transaction_end_date)}}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="d-flex flex-column flex-row-auto col-lg-12" v-if="form.activeView == 3 && sourceItemInfo !== null && sourceItemInfo !== undefined && sourceItemInfo !== ''"> 
                            <div class="d-flex align-items-center bg-light-success rounded border-success border border-dashed min-w-750px px-7 py-3">  
                                <table class="table align-middle table-row-dashed table-hover">
                                    <thead>
                                        <tr class="text-start text-gray-400 fw-bolder fs-7 text-uppercase gs-0 fw-bolder text-gray-800">
                                            <th>{{ $t('transaction_type') }}</th>
                                            <th>{{ $t('sub_type') }}</th>
                                            <th>{{ $t('transaction_no') }}</th>
                                            <th>{{ $t('amount') }}</th>
                                            <th>{{ $t('closed') }}</th>
                                            <th>{{ $t('remain') }}</th>
                                            <th>{{ $t('currency') }}</th>
                                            <th>{{ $t('rate') }}</th>
                                            <th>
                                                <div>{{this.localCurrency}}</div>
                                                {{ $t('amount') }}
                                            </th>
                                            <th>
                                                <div>{{this.localCurrency}}</div>
                                                {{ $t('closed') }}
                                            </th>
                                            <th>
                                                <div>{{this.localCurrency}}</div>
                                                {{ $t('remain') }}
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody class="text-gray-600 fw-bold">
                                        <tr class="odd">
                                            <td>{{sourceItemInfo.transaction_type_name}}</td>
                                            <td>{{sourceItemInfo.transaction_subtype_name}}</td>
                                            <td>{{sourceItemInfo.transaction_number}}</td>
                                            <td>{{sourceItemInfo.amount}}</td>
                                            <td>{{sourceItemInfo.used_amount}}</td>
                                            <td>{{sourceItemInfo.remain_amount}}</td>
                                            <td>{{sourceItemInfo.currency}}</td>
                                            <td>{{sourceItemInfo.rate}}</td>
                                            <td>{{sourceItemInfo.local_amount}}</td>
                                            <td>{{sourceItemInfo.used_local_amount}}</td>
                                            <td>{{sourceItemInfo.remain_local_amount}}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>

                    <div class="row" v-if="form.activeView == 2">
                        <div class="col-lg-12">
                            <div class="card card-xxl-stretch mb-5 mb-xxl-10 bg-lighten rounded-3 border border-gray-300">
                                <div class="p-3">
                                    <div class="dataTables_wrapper dt-bootstrap4 no-footer">    
                                        <div class="table-responsive-lg">
                                            <DxDataGrid id="gridContainer" :key="$i18n.locale" 
                                                :show-borders="true" 
                                                key-expr="id" 
                                                :data-source="lists" 
                                                :allow-column-reordering="true"  
                                                :allow-column-resizing="true" 
                                                :column-auto-width="true" 
                                                :row-alternatin-enabled="true"
                                                :hover-state-enabled="true" 
                                                :show-row-lines="true" 
                                                :customize-columns="onCustomizeColumn"
                                                @exporting="this.$onExporting($event , form.balance_closing_type == 1 ? 'Collection-list' : (form.balance_closing_type == 2 ? 'Payment-list' : 'Collection and Payments'))"
                                                @option-changed="handlePropertyChange"> 

                                                <DxFilterRow :visible="true"/>
                                                <DxHeaderFilter :visible="true"/>
                                                <DxGroupPanel :visible="true"/>      
                                                <DxExport :enabled="this.$getUser().is_allow_export" :formats="['xlsx','pdf']" :allow-export-selected-data="false"/>
                                                <DxPaging :page-size="10"/>
                                                <DxPager :visible="false" :allowed-page-sizes="pageSizes" :show-page-size-selector="showPageSizeSelector" :show-info="true" :show-navigation-buttons="true"/> 
                                                <DxSearchPanel :visible="true"/> 
                                                <DxScrolling mode="virtual" row-rendering-mode="virtual" />
                                                <DxColumn data-field="detail" caption="..." cell-template="detail-cell-template" alignment="center" :allow-exporting="false"  :width="100" />

                                                <DxColumn data-field="id" caption="" alignment="right" cell-template="id-cell-template" :allow-exporting="false"/> 
                                                <DxColumn data-field="transaction_date" :caption="$t('transaction_date')" data-type="date" alignment="right" format="dd.MM.yyyy" header-cell-template="transaction_date-header"/>   
                                                <DxColumn data-field="transaction_due_date" :caption="$t('due_date')" data-type="date" alignment="right" format="dd.MM.yyyy" header-cell-template="transaction_due_date-header" />   
                                                <DxColumn data-field="transaction_type_name" :caption="$t('type')" />
                                                <DxColumn data-field="transaction_subtype_name" :caption="$t('sub_type')" />
                                                <DxColumn data-field="account_name" :caption="$t('account')" />
                                                <DxColumn data-field="transaction_number" :caption="$t('transaction_no')" />  
                                                <DxColumn data-field="ref_number" :caption="$t('ref_no')" />  
                                                <DxColumn v-if="form.balance_closing_type == 0" data-field="item_type" :sorting-method="this.$numericSort" :caption="$t('balance_type')" cell-template="item_type-cell-template" header-cell-template="item_type-header"/>
                                                <DxColumn data-field="amount" :sorting-method="this.$numericSort" :caption="$t('amount')" alignment="right" />
                                                <DxColumn data-field="used_amount" :sorting-method="this.$numericSort" :caption="$t('closed_amount')" alignment="right" />
                                                <DxColumn cssClass="bg-light-danger" data-field="remain_amount" :sorting-method="this.$numericSort" :caption="$t('remain_amount')" alignment="right" cell-template="remain_amount-cell-template"/>
                                                <DxColumn data-field="currency" :caption="$t('currency')" />  
                                                <DxColumn data-field="rate" :caption="$t('rate')" :sorting-method="this.$numericSort" alignment="right" /> 
                                                <DxColumn data-field="local_amount" :sorting-method="this.$numericSort" :caption="$t('local_amount')" alignment="right" /> 
                                                <DxColumn data-field="used_local_amount" :sorting-method="this.$numericSort" :caption="$t('local_closed_amount')" alignment="right" /> 
                                                <DxColumn data-field="remain_local_amount" :sorting-method="this.$numericSort" :caption="$t('local_remain_amount')" alignment="right" />

                                                <!-- Yerel para birimi gösterimi için özel sütun şablonu oluşturulur --> 
                                                <template #headerLocalTemplate="{ data: data }">
                                                    <div v-html="setColumnTemplateForLocal(data)"></div> 
                                                </template>
                                                <template #transaction_date-header>
                                                    <div>{{ $t('transaction_date') }}</div>
                                                </template>
                                                <template #transaction_due_date-header>
                                                    <div>{{ $t('due_date') }}</div>
                                                </template>
                                                <template #item_type-header>
                                                    <div>{{ $t('balance_type') }}</div>
                                                </template>

                                                <template #detail-cell-template="{ data }">
                                                    <button type="button" class="btn btn-xs btn-primary" @click="changeView(3, data.data)">
                                                        {{ $t('select') }}
                                                        <i class="bi bi-chevron-right fs-8 mb-1"></i>
                                                    </button>
                                                </template>
                                                <template #id-cell-template="{ data }">
                                                    <a href="#" class="text-gray-800 text-hover-primary">
                                                        {{ (this.pageSize * this.pageIndex) + data.rowIndex + 1 }}
                                                    </a>
                                                </template>
                                                <template #item_type-cell-template="{ data }">
                                                    <span class="text-gray-700 p-3 align-middle"> 
                                                        <span v-if="data.data.item_type == 1"> {{ $t('collection') }} </span>
                                                        <span v-if="data.data.item_type == 2">{{ $t('payment') }}</span>
                                                    </span>
                                                </template>
                                                <template #remain_amount-cell-template="{ data }">
                                                    <span class="p-3 align-middle" :class="{'text-danger fw-bold': parseFloat(data.data.remain_amount) > 0, 'text-gray-700': parseFloat(data.data.remain_amount) == 0}">
                                                        {{data.data.remain_amount}}
                                                    </span>
                                                </template>
                                                <DxSummary :calculate-custom-summary="setSummaries">
                                                <DxTotalItem column="id" summary-type="count" :display-format="`${$t('record')}: {0}`" show-in-column="isSelected"/>
                                                    <DxGroupItem
                                                        :show-in-group-footer="true"
                                                        name="local_amount"
                                                        summary-type="custom"
                                                        show-in-column="local_amount"
                                                        display-format="{0}"
                                                    /> 
                                                    <DxTotalItem name="local_amount"
                                                        summary-type="custom"
                                                        show-in-column="local_amount"
                                                    />
                                                </DxSummary>
                                            </DxDataGrid>
                                        </div>
                                    </div> 
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-12 p-6" v-show="form.activeView == 3">
                        <BalanceClosingList ref="BalanceClosingList" :is-manual-operation="true" modal-type="editItem" :active-tab="form.activeView == 3 ? 'BalanceClosing' : ''"></BalanceClosingList>
                    </div>
                    <div class="col-lg-12 mt-0" v-if="form.activeView == 3 && this.$isCredentialActive(26,'I')">
                        <div class="row">
                            <div class="d-grid gap-2">
                                <button class="btn btn-success btn-lg mb-4" type="submit" @click="onSaveBalanceClosing()" data-kt-indicator="on"> 
                                    <span class="svg-icon svg-icon-2"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path opacity="0.3" d="M10 18C9.7 18 9.5 17.9 9.3 17.7L2.3 10.7C1.9 10.3 1.9 9.7 2.3 9.3C2.7 8.9 3.29999 8.9 3.69999 9.3L10.7 16.3C11.1 16.7 11.1 17.3 10.7 17.7C10.5 17.9 10.3 18 10 18Z" fill="currentColor"/>
                                    <path d="M10 18C9.7 18 9.5 17.9 9.3 17.7C8.9 17.3 8.9 16.7 9.3 16.3L20.3 5.3C20.7 4.9 21.3 4.9 21.7 5.3C22.1 5.7 22.1 6.30002 21.7 6.70002L10.7 17.7C10.5 17.9 10.3 18 10 18Z" fill="currentColor"/>
                                    </svg>
                                    </span> 
                                    <strong v-if="!this.isSaving"> {{ $t('save_balance_closing') }} </strong> 
                                    <span class="indicator-progress" v-if="this.isSaving">
                                        {{ $t('saving-transaction-please-wait') }} <span class="spinner-border spinner-border-sm align-middle ms-2"></span>
                                    </span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal fade" id="kt_modal_add_contact" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" role="dialog" aria-modal="true">
			<AddNewContact ref="AddNewContact"/>
		</div>
        <!-- Search Account Modal -->
        <div class="modal fade" id="kt_search_account_modal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" role="dialog" aria-modal="true">
            <SearchAccountWithSelect ref="SearchAccountWithSelect" :account-type="12"/>
        </div>
        <!-- Transaction List -->
        <div class="modal fade" id="kt_modal_transaction_list" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" role="dialog" aria-modal="true">
            <TransactionListModal ref="TransactionListModal" :transaction-type="11" :account-id="form.account_id" :account-name="form.account_name" />
        </div>
        <!--AccountReports-->
        <div class="modal fade" id="kt_modal_account_report_selection" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" role="dialog" aria-modal="true">
            <AccountReports ref="AccountReports" :account-name="form.account_name" :account-id="form.account_id" :account-type="form.account_type" />
        </div>
    </div>
</template>

<script>
import axios from "axios";
import moment from 'moment';
import { DxDataGrid, DxFilterRow, DxHeaderFilter, DxGroupPanel, DxExport, DxPaging, DxPager, DxColumn, DxSearchPanel, DxSummary, DxTotalItem, DxGroupItem, DxScrolling  } from 'devextreme-vue/data-grid';
import AddNewContact from '../Modals/AddNewContact.vue';
import SearchAccountWithSelect from '../../Accounts/Modals/SearchAccountWithSelect.vue';
import TransactionListModal from '../TransactionListModal.vue'; 
import BalanceClosingList from '../Modals/BalanceClosingList.vue';
import NoModalRecentlyUsedAccounts from '../../NoModalRecentlyUsedAccounts.vue';

export default {
  name: "BalanceClosingOperations",
  components:{
    DxDataGrid, DxFilterRow, DxHeaderFilter, DxGroupPanel, DxExport, DxPaging, DxPager, DxColumn, DxSearchPanel, AddNewContact, SearchAccountWithSelect, TransactionListModal, DxSummary, DxTotalItem, DxGroupItem, DxScrolling, BalanceClosingList,NoModalRecentlyUsedAccounts
  },
  data() {
    return {        
        pageSize: 10,
        pageIndex: 0,
        dropDownOptions: { width: 600 },
        accountLatestList: [],
        balanceClosingTypeList:[{ id: 1, text: this.$t('collections')}, { id: 2, text: this.$t('payments')}, { id: 3, text: this.$t('with_remain')}, { id: 0, text: this.$t('all')}],
        form: {
            docket_item_id: null,
            currency: null,
            account_type: 12,
            account_id: null,
            account_name: null,
            balance_closing_type: 1,
            activeView: 1,
            transaction_start_date: moment().subtract((parseInt(this.$getUser().list_date_range)), 'days'),
            transaction_end_date: moment()
        },
        menuSelection: '/BalanceClosingHelppage',
        iconView: false,
        lists: [],
        localCurrency: null,
        selectedAccountInfo: {},
        selectedAccount: {
            name: null,
            account_type: null,
            account_type_name: null,
            account_id: null,
            account_name: null,
            qr_code: null,
            notes: null,
            company_type_id: null,
            account_number: null,
            contact_name: null,
            email: null,
            mobile_phone: null,
            phone: null,
            postcode: null,
            address: null,
            country: null,
            city: null,
            vat_number: null,
            payment_value: null,
            sales_channel_name: null,
            customer_type_name: null,
            expense_type_name: null,
            expense_group_name: null,
            branch_name: null
        },
        balanceClosingList: [],
        isSaving: false,
        sourceItemInfo: {},
        bgClasses: [
            {id: 0, text: 'bg-light-primary text-primary'},
            {id: 1, text: 'bg-light-success text-success'},
            {id: 2, text: 'bg-light-info text-info'},
            {id: 3, text: 'bg-light-danger text-danger'},
            {id: 4, text: 'bg-light-warning text-warning'},
            {id: 5, text: 'bg-light-secondary text-gray-800'},
        ],
    };
  },
  computed: {
    previewDate(){
      return (value)=>{
       if (value) {
          return moment(new Date(value)).format('DD.MM.YYYY')
        }
      }
    },
    showPageSizeSelector() {
        return this.lists.length > this.pageSize;
    },
    pageSizes() {
        let arr = [];
        let x = 1;
        let loop = (this.lists.length / this.pageSize);
        for (let i = 1; i <= loop && i <= 5; i++) {
            arr.push(this.pageSize * x);
            x++;
        }
        if(loop > 5) arr.push(100);
        if(loop > 1) arr.push('all');
        return arr;
    },
    getBalanceClosingTypeName(){
      return (value)=>{
       if (value !== null && value !== '' && value !== undefined) {
          return this.balanceClosingTypeList.find(element => {
            return element.id == value
          }).text;
        }
      }
    },
    setColumnTemplateForLocal(){
        return (value)=>{
            const captionValue = value.column.caption.replace(this.$t('local'), ' ');
            return this.localCurrency == null ? this.$t(captionValue) : this.localCurrency + '<br>' + this.$t(captionValue);
        }
    },
    getRandomClass(){
        return (value)=>{ return this.bgClasses[value] ? this.bgClasses[value].text : 'bg-light-info text-info'}
    },
    getTotals() {
        return (array)=>{
            if (array) {
                let sum = 0;
                array.map(x => {
                    sum += parseFloat(x.total_balance_local.replaceAll(',', ''))
                });
                return this.$globalParseFloat(sum);
            }
        }
    },
    getAverageTotals() {
        return (array)=>{
            if (array) {
                let avarage = 0;
                array.map(x => {
                    avarage = x.average_due_state
                });
                return avarage;
            }
        }
    },
  },
  methods: { 
    getData() {
        this.$Progress.start(); 
        this.$setSessionStorage('tmp_session_id', null);
        this.isSaving = false;
        this.accountLatestList = [];
        this.localCurrency = this.$getUser().currency_code;
          
        const params = {
            session_id : this.$getUser().session_id,
            account_type : 12 // Customer: 1 + Supplier: 2
        };
        const that = this;
        axios.post('api/Invoice/GetLatestUsedAccounts', params, {'Content-Type': 'application/json'})
        .then((response) => {
            if(response.data.error == null || response.data.error == 'undefined' || response.data.error == ''){
                this.accountLatestList = response.data;
            }
            
            if(this.$route.params.bcData !== null && this.$route.params.bcData !== undefined && this.$route.params.bcData !== '') {
                const bcData = JSON.parse(this.$route.params.bcData);
                if(bcData !== null && bcData !== undefined && bcData !== '') {
                    this.form.activeView = 3;
                    this.getAccountDetail(bcData.account_id);
                    this.getBalanceClosingTemp(bcData);
                }
            }
        })
        .catch((error) => {
            console.error(error);
            that.$Progress.finish();
        })
        .finally(() => { 
            that.$Progress.finish();
        });
    },
    getCollections(docketInfo) {        
        //Transaction listesinden docket secildiyse docket bilgilerine gore listeleniyor
        if(docketInfo !== null && docketInfo !== '' && docketInfo !== undefined) {
            this.form.account_id = docketInfo.account_id;
            this.form.balance_closing_type = docketInfo.item_type;
            this.getAccountDetail(docketInfo.account_id);
            this.form.activeView = 2;
        }

        this.lists = [];
        this.$Progress.start();
        this.form.transaction_start_date = (this.form.transaction_start_date == null || this.form.transaction_start_date == '') ? moment() : this.form.transaction_start_date;
        this.form.transaction_end_date = ( this.form.transaction_end_date == null || this.form.transaction_end_date == '') ? moment () : this.form.transaction_end_date;
        const queryParameter = {
            session_id: this.$getUser().session_id,
            account_id: this.form.account_id,
            first_date: moment(this.form.transaction_start_date).format('YYYY-MM-DD'),
            last_date: moment(this.form.transaction_end_date).format('YYYY-MM-DD'),
            bc_type: this.form.balance_closing_type,
            docket_id: (docketInfo !== null && docketInfo !== '' && docketInfo !== undefined) ? docketInfo.id : null
        };   
        const that = this;
        axios.post('/api/BalanceClosing/GetTransactionsForBalanceClosing', queryParameter, {'Content-Type': 'application/json'}) 
        .then((response) => {  
            this.lists = response.data;
            this.$Progress.finish();
        })
        .catch(() => {
            this.$Progress.finish();
        })
        .finally(function() {
            that.$Progress.finish();
        });
    },
    onSaveBalanceClosing() {
        this.$swal.fire({
            title: this.$t('are_you_sure_you_want_to_save_this_balance_closing_operation'),
            confirmButtonColor: "#50cd89",
            showDenyButton: false,
            showCancelButton: true,
        cancelButtonText: this.$t('cancel'),
            confirmButtonText: this.$t('save'),
            icon: 'info'
        }).then((result) => {
            if (result.isConfirmed) { 
                this.isSaving = true;
                let selectedBalances = [];
                this.balanceClosingList.forEach((value) => {
                    if(value.isSelected && !value.isBalanceToRefundExist) {
                        selectedBalances.push({ balance_id: value.id, amount: value.closing_amount_input });
                    }
                });
                const params = {
                    session_id: this.$getUser().session_id,
                    tmp_session_id: this.$getSessionStorage('tmp_session_id'),
                    balanceItems: selectedBalances,
                    docket_item_id: this.form.docket_item_id,
                    bc_type: this.form.balance_closing_type,
                    account_id: this.form.account_id
                };
                const that = this;
                axios.post('api/BalanceClosing/SaveBalanceOperation', params, {'Content-Type': 'application/json'})
                .then(() => {
                    this.changeView(2);
                })
                .catch(() => {
                    that.isSaving = false;
                })
                .finally(() => { 
                    that.isSaving = false;
                });
            }
        });
    },
    handlePropertyChange(e) {
        if(e.name == "paging") { this.pageIndex = e.component.pageIndex(); }
    },
    onSelectItem(item) {
        this.lists.forEach((value) => { 
            if (item.id !== value.id) { value.isSelected = false; }
        });    
    },
    getAccountDetail(id) {
        if (id == '-1' || id == null || id == undefined) return;
        const params = {
            id: id,
            session_id: this.$getUser().session_id
        }; 
        axios.post('api/CompanyAccounts/GetAccountById', params, {'Content-Type': 'application/json'})
        .then((response) => {
            if (response.data.account_type == 1 || response.data.account_type == 2) {
                response.data.name = this.$unlock(response.data.name);
                response.data.customer_account_number = this.$unlock(response.data.customer_account_number);
                response.data.customer_address = this.$unlock(response.data.customer_address);
                response.data.customer_city = this.$unlock(response.data.customer_city);
                response.data.customer_district = this.$unlock(response.data.customer_district);
                response.data.customer_country = this.$unlock(response.data.customer_country);
                response.data.customer_postcode = this.$unlock(response.data.customer_postcode);
                response.data.customer_email = this.$unlock(response.data.customer_email);
                response.data.customer_mobile_phone = this.$unlock(response.data.customer_mobile_phone);
                response.data.customer_contact_name =  this.$unlock(response.data.customer_contact_name);
                response.data.customer_phone =  this.$unlock(response.data.customer_phone);
                this.selectedAccountInfo = response.data;
                this.form.account_id = response.data.id;
                this.form.account_name = response.data.name;
                this.form.account_type = response.data.account_type;
                this.form.balance_closing_type = response.data.account_type == 2 ? 2 : 1;
            }
        }); 
    },
    changeView(activeView, data) {
        this.$checkSelect2Validation('poliform');
        if(!document.forms['poliform'].reportValidity()){
            return;
        }
        this.form.activeView = activeView;

        if(activeView == 2) {
            this.getCollections();
        }
        if(activeView == 3) {
            this.getBalanceClosingTemp(data);
        }
    },
    getBalanceClosingTemp(balanceItem) {
        this.sourceItemInfo = balanceItem;
        this.form.transaction_start_date = (this.form.transaction_start_date == null || this.form.transaction_start_date == '') ? moment() : this.form.transaction_start_date;
        this.form.transaction_end_date = ( this.form.transaction_end_date == null || this.form.transaction_end_date == '') ? moment () : this.form.transaction_end_date;
        const parameters = {
            session_id: this.$getUser().session_id,
            docket_item_id: balanceItem.transaction_detail_id,
            bc_type: balanceItem.item_type
        };
        axios.post('/api/BalanceClosing/GetBalanceClosingTemp', parameters, {'Content-Type': 'application/json'})
        .then((response) => {
            if(response.data.error == null || response.data.error == 'undefined' || response.data.error == ''){
                this.$setSessionStorage('tmp_session_id', response.data);
            }
            this.form.docket_item_id = balanceItem.transaction_detail_id;
            this.form.currency = balanceItem.currency;
            this.$refs.BalanceClosingList.form = {
                account_id: this.form.account_id,
                id: balanceItem.transaction_detail_id,
                amount: Math.abs(parseFloat(balanceItem.amount.replace(/,/g,''))),
                item_type: balanceItem.item_type,
                docket_type: balanceItem.transaction_type
            };
            this.$refs.BalanceClosingList.getData(true);
            this.$refs.BalanceClosingList.balanceForm.currency = balanceItem.currency;
           
        })
        .catch((error) => {
           console.error(error);
        });
    },
    onClickCancel() {
        this.$swal.fire({
            title: this.$t('you_have_not_saved_yet_are_you_sure_you_want_to_cancel'),
            confirmButtonColor: '#f1416c',
            showDenyButton: false,
            showCancelButton: true,
        cancelButtonText: this.$t('cancel'),
            confirmButtonText: this.$t('yes')
        }).then((result) => {
            if (result.isConfirmed) {
                this.lists = [];
                this.$router.push({ path: '/BalanceClosingOperations' }).then(() => { this.$router.go(0) });
            }
        });
    },
    openCreateContactModal() {
        this.$refs.AddNewContactButton.click();
        this.$refs.AddNewContact.getData();
        if (this.form.invoice_type == 1 || this.form.invoice_type == 4) {
            this.$refs.AddNewContact.createContactForm.account_type = 1;
        }
        if (this.form.invoice_type == 2 || this.form.invoice_type == 3) {
            this.$refs.AddNewContact.createContactForm.account_type = 2;
        }
    },
    onSuccessNewAccount(account_id) {
        this.getAccountDetail(account_id);
    },
    async helpPageViewIcon()
    {
        const queryparameter = {
            session_id : this.$getUser().session_id,
            menu_selection : '/BalanceClosingHelppage'
        };
        axios.post('api/HelpPage/HelpPagesContent', queryparameter, {'Content-Type': 'application/json'})
        .then((response) => { 
            if(!response.data.error){ 
                this.iconView = response.data;
            }
        })
    }, 
    openSearchModal(accountType, searchText) {
        if(accountType == 7) {
            this.$refs.SearchStockAccountWithSelect.getData(7, this.form.process_type, this.form.invoice_type, searchText, true);
        } else {
            this.$refs.SearchAccountWithSelect.getData(-4, 0, 0, searchText, true); /* account_type, process_type, invoice_type, search_text, is_create_account */
        }
    },
    onOpenTransactionListModal() {
        this.$refs.TransactionListModal.getData();
    },
    onOpenAccountReport(item){
        let accountInfo = {
            id: (item !== null && item !== undefined && item !== '') ? item.id : this.form.account_id, 
            name: (item !== null && item !== undefined && item !== '') ? item.name : this.form.account_name
        };
        this.$refs.AccountReports.getData(accountInfo);
        this.$refs.AccountReports.setModalCriteriasToDefault();
    },
    onClickSearchButton(refName) {
        this.$refs[refName].click();
    },
    setSummaries(options){
        if(options.name == "local_amount"){
            if(options.summaryProcess === 'start'){ options.totalValue = 0; }
            else if(options.summaryProcess === 'calculate'){ 
                var local_amount = parseFloat(options.value.local_amount.replaceAll(',', ''));
                (options.totalValue += local_amount); 
            }
            else if(options.summaryProcess === 'finalize'){
                options.totalValue = Intl.NumberFormat('en-US', { minimumFractionDigits: 2 }).format(options.totalValue);
            }
        }
    },
    onCustomizeColumn(e){
        if(e){
            if(!e._isUpdated){
                if(e.length > 0){ 
                    e._isUpdated = true;
                }
                e.forEach((column) => {
                    if(column.dataField == 'local_amount'){ 
                        column.caption = this.$t('local_amount');
                        column.headerCellTemplate = 'headerLocalTemplate';
                    }
                    if(column.dataField == 'used_local_amount'){ 
                        column.caption = this.$t('local_closed_amount');
                        column.headerCellTemplate = 'headerLocalTemplate';
                    }
                    if(column.dataField == 'remain_local_amount'){ 
                        column.caption = this.$t('local_remain_amount');
                        column.headerCellTemplate = 'headerLocalTemplate';
                    }
                });  
            } 
        } 
    },
    getAccountBalances(item) {
        item.isCollapsed = !item.isCollapsed;
        if(item.isCollapsed) {
            const parameters = {
                session_id: this.$getUser().session_id,
                account_id:  item.id
            }; 
            axios.post('/api/Helper/GetAccountCurrencyBalances', parameters, {'Content-Type': 'application/json'})
            .then((response) => {
                if(response.data.error == null || response.data.error == 'undefined' || response.data.error == ''){
                    if(response.data.balance.length > 0) item.balances = response.data.balance;
                    item.totals = response.data.summary;
                }
            })
            .catch((error) => {
                console.error(error);
            });
        }
    },
    onBackStep() {
        this.form.activeView--;        
        if(this.form.activeView == 2) {
            this.getCollections();
        }
    }
  },
  created() { 
    this.$removeSessionStorage('tmp_session_id');
    this.helpPageViewIcon();
    this.$setSessionStorage('refreshList', true);
    this.getData();
  }
};
</script>
<style scoped> 
.dx-texteditor.dx-editor-outlined {
    background: #fff;
    border: 1px solid #ddd;
    border-radius: 6px;
    padding: 4px !important;
    color: black;
} 
</style>